import { useAppSelector } from '../../reducers';
import { highestProductLevelFromProductInventorySelector, ownedHubSpotCreditsTotalSelector } from '../../selectors/ProductInventorySelectors';
import { currentSuiteSkuIdsForProductLevelSelector } from '../../selectors/ProductsSelectors';
import { HubSpotCreditsTilesContainer } from '../merch-card/hubspot-credits/HubSpotCreditsTilesContainer';
import BreezeValuePropositions from './BreezeValuePropositions';
import { jsx as _jsx } from "react/jsx-runtime";
const JuneBreezeIntelligencePackInfo = ({
  screen
}) => {
  const ownedQuantity = useAppSelector(state => {
    return ownedHubSpotCreditsTotalSelector(state);
  });
  const showValuePropositions = ownedQuantity > 0;
  const highestProductLevelOwned = useAppSelector(highestProductLevelFromProductInventorySelector);
  const isFreeOrProspect = highestProductLevelOwned === 'FREE';
  const unlockHubSpotCreditsSkuIds = useAppSelector(state => {
    if (!isFreeOrProspect) {
      return null;
    }
    return currentSuiteSkuIdsForProductLevelSelector(state, {
      productLevel: 'STARTER'
    });
  });
  return showValuePropositions ? /*#__PURE__*/_jsx(BreezeValuePropositions, {
    screen: screen
  }) : /*#__PURE__*/_jsx(HubSpotCreditsTilesContainer, {
    screen: screen,
    hubSpotCreditsFeature: "BREEZE",
    productApiName: 'hubspot-credits-committed',
    unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
    shouldShowUnlockHubSpotCreditsInfo: isFreeOrProspect
  });
};
export default JuneBreezeIntelligencePackInfo;